<div class="map">
  <div class="shipName">
    <mat-icon matPrefix class="search">search</mat-icon>
    <input
      matInput
      class="form-control"
      placeholder="Enter ship name"
      [(ngModel)]="shipName"
      id="shipName"
      [matAutocomplete]="autoShip"
      (input)="filterShipNames($event)"
    />
    <mat-autocomplete
      #autoShip="matAutocomplete"
      (optionSelected)="onShipSelected($event)"
    >
      <mat-option *ngFor="let ship of shipNameSuggestions" [value]="ship.ship">
        {{ ship.ship }}
      </mat-option>
    </mat-autocomplete>
  </div>

  <div id="windy"></div>
  <button class="custom-play-button" *ngIf="playButton">
    {{ isAnimating ? "Pause" : "Ship Animation" }}
  </button>
  <div class="legend" *ngIf="legend">
    <img [src]="legendImg" class="color-bar-image" />
  </div>
</div>
